// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { createTheme } from '@mui/material';
import cantonLogoNewBlack from '../assets/cantonLogoNewBlack.svg';
import cantonLogoNewWhite from '../assets/cantonLogoNewWhite.svg';
import digitalAssetLogo from '../assets/digitalAssetLogo.png';
import { Branding } from '../utils/branding';
import baseline from './baseline';

const utilies: Branding = {
  loginLogo: <img alt="" src={cantonLogoNewBlack} height="64" />,
  loginLogoDark: <img alt="" src={cantonLogoNewWhite} />,
  headerLogo: <img alt="" src={cantonLogoNewBlack} height="32px" />,
  headerLogoDark: <img alt="" src={cantonLogoNewWhite} height="32px" />,
  companyLogo: (
    <img alt="" src={digitalAssetLogo} height="18px" style={{ display: 'inline-block' }} />
  ),
};

export default { branding: utilies, theme: createTheme(baseline) };
